import API from "./api";

// upload image file
export const uploadProductImage = async (formData) => {
  const res = await API.post("/product-images/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return res.data.images;
};

// get images by product
export const getProductImages = async (productId) => {
  const res = await API.get(`/product-images/${productId}`);
  return res.data.images;
};

// delete image
export const deleteProductImage = async (id) => {
  const res = await API.delete(`/product-images/${id}`);
  return res.data.image;
};